import React, { useState, useEffect } from 'react';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import 'react-loading-skeleton/dist/skeleton.css'
import { useNavigate, useParams } from 'react-router-dom';
import init from '../../firebase';


const EditInvoiceInfo = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState({
        business_name: '',
        mobno: '',
        email: '',
        gst: '',
        bankName: '',
        accountNo: '',
        ifscNo: '',
        t_c: '',
        address:""
    })
    const staffFinder = async () => {
        const collectionRef = doc(init.db, 'vendorInvoiceInfo', id);
        const res = await getDoc(collectionRef);
        const myRes = res.data()
        setData(myRes)
    }
    useEffect(() => {
        if (!id) return
        staffFinder()
    }, [id])
    const formHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setData({ ...data, [name]: value })
    }
    const btnHandler = async (e) => {
        e.preventDefault()
        const { business_name, mobno, email, gst, bankName, accountNo, ifscNo, t_c, address } = data;
        if (business_name !== '' && mobno !== "" && email !== "" && gst !== "" && bankName !== "" && accountNo !== "" && ifscNo !== "" && address !== "") {
        try {
            await updateDoc(doc(init.db, "vendorInvoiceInfo", id), {
                business_name, mobno, email, gst, bankName, accountNo, ifscNo, t_c, address 
            });
            toast.success('Invoice Basic Info updated successfully.')
            navigate('/dashboard/invoice-basic')
        } catch (err) {
            console.log(err)
        }
    }else{
        toast.error('please fill your all field');
    }

    }
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-header  d-flex justify-content-between align-items-center'>
                                <div className='text-center'>
                                   <center><h4>Update Invoice Information</h4></center>
                                </div>
                            </div>
                            <div className='card-body'>
                            <form className="form-horizontal">
                        <div className="card-body">
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Business Name <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data.business_name}
                                    name='business_name'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Business Name"
                                />
                            </div>
                        
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Email<span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data.email}
                                    name='email'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Email"
                                />
                            </div>
                          
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Address <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data.address}
                                    name='address'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Address"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Business Name <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data.mobno}
                                    name='mobno'
                                    type="tel"
                                    maxLength={10}
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Mobile Number"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >GST Number<span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data.gst}
                                    name='gst'
                                    type="number"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Gst Number"
                                />
                            </div>
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Bank Name<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler} value={data.bankName}
                                    type="text"
                                    className="form-control"
                                    name='bankName'
                                    placeholder="Enter your Bank Name"
                                    
                                />
                            </div>

                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Accout Number<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler}
                                    value={data.accountNo}
                                    type="number"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter Account Number"
                                    name='accountNo'
                                />
                            </div>
                            
                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >IFSC Code<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler}
                                    value={data.ifscNo}
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter IFSC code"
                                    name='ifscNo'
                                />
                            </div>
                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Terms & Conditions<span className='text-danger'>*</span></label>
                                <textarea
                                    onChange={formHandler}
                                    value={data.t_c}
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter Terms & Conditions"
                                    name='t_c'
                                />
                            </div>
                            <button variant="" className='btn text-white ' style={{ backgroundColor: '#085f9a' }} onClick={btnHandler}>
                        Update
                    </button>
                        </div>
                    </form>
                   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditInvoiceInfo